/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * The record a page shows, for phone links inside it: a call placed from a
 * field lands on that record's timeline, as one from the header call button
 * does. Pages provide it around their v2 layout; without it a call is still
 * placed, just not filed against a record.
 */

import { createContext, useContext } from "react";

const RecordCallContext = createContext(null);

export const RecordCallProvider = RecordCallContext.Provider;

/** { parentTable, parentId, accountId, contactId, leadId, dealId, caseId } or null. */
export function useRecordCallContext() {
  return useContext(RecordCallContext);
}
